(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alltidmff-marquee"] && !Shopify.designMode) return;
  try {
    
class KsMarquee extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (e) => {
      console.log(e.target) 
      if (e.target.querySelector('.ks-marquee')) {
        init()
      }
    })
  }

  init () {
    const list = this.querySelector('ul')
    const marqueeWidth = list.scrollWidth
    const marqueeLength = list.querySelectorAll('li').length

    list.insertAdjacentHTML('beforeEnd', list.innerHTML)
    list.insertAdjacentHTML('beforeEnd', list.innerHTML)

    list.querySelectorAll('li').forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    let style = `
      <style>
        #ks-marquee-${this.dataset.sectionId} ul {
          animation-name: ks-marquee-animation-${this.dataset.sectionId};
          animation-duration: ${this.dataset.animationDuration}s;
        }
        @keyframes ks-marquee-animation-${this.dataset.sectionId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `
    if (this.dataset.marqueeDirection === 'right') {
      style += `
        <style>
          @keyframes ks-marquee-animation-${this.dataset.sectionId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `
    }

    this.insertAdjacentHTML('beforeBegin', style)
  }
}
customElements.define('ks-marquee', KsMarquee)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
